import React from 'react'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../Core/NewFillButton'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

export const UploadFlightLogsPopup = () => {
  const [open, setOpen] = React.useState({ open: false, func: null })

  const handleClose = () => setOpen({ open: false, func: null })

  const Confirm = () => {
    open.func()
    setOpen({ open: false, func: null })
  }

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.FLIGHT_LOGS_MORE_LOGS_POPUP_SHOW,
      (callback) => {
        setOpen({ open: true, func: callback })
      }
    )

    return function cleanup() {
      EventEmitterService.unsubscribe(
        EventKey.FLIGHT_LOGS_MORE_LOGS_POPUP_SHOW,
        id
      )
    }
  }, [])

  return (
    <SkywatchDialog
      open={open.open}
      closeDialog={handleClose}
      maxWidth={'xs'}
      circleHeader={
        <ElevatedCircle>
          {' '}
          <CloudUploadIcon className="blue" />{' '}
        </ElevatedCircle>
      }
      closeTitle={'Your Policy'}>
      <FlexView column>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">
          First time uploading flight logs?
        </div>
        <div className="text-body black margin-bottom-basic">
          Upload at least 5 flights of 5 minutes flying to get your initial
          Safety Score.
        </div>
        <br />
        <div className="text-body black margin-bottom-basic">
          Already have a score? You can submit less than 5 flights to improve
          your score.
        </div>
        <br />
        <FlexView className="space-between full-width">
          <NewFillButton darkblue onClick={handleClose}>
            Upload More Logs
          </NewFillButton>
          <NewFillButton onClick={Confirm}>Submit My Logs</NewFillButton>
        </FlexView>
      </FlexView>
    </SkywatchDialog>
  )
}
